import React from 'react';
import PropTypes from 'prop-types';
import Status from '../status';
import Ventilator from '../assets/components/Ventilator';
import { WHITE_COLOR, DISABLE_COLOR, PRIMARY_COLOR_HIGHLIGHT } from '../colors';
import './index.css';

/**
 * DEPRECATED
 * Status ventilator
 * Shows the status component ventilator
 * Parameters (Props):
 * @param bool disable
 * @param object styles : styles of the within box
 * @param object stylesBox: styles of the outside box
 * @param function onClick
 * @param string size: default medium [small | medium | big]
 * @param string inverted: if the value is true then the icon color is white
 * @param string tooltip
 * @param string label
 */
export default class StatusVentilator extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toggleHover = this.toggleHover.bind(this);
    this.state = {
      hover: false,
    };
  }

  /**
   * Toggle hover
   */
  toggleHover() {
    const { hover } = this.state;
    this.setState({ hover: !hover });
  }

  render() {
    const {
      inverted,
      onClick,
      disable,
      stylesBox,
      styles,
      size,
      tooltip,
      label,
    } = this.props;
    const { hover } = this.state;
    let color = DISABLE_COLOR;
    let styleButton = {};
    if (disable) {
      styleButton = { fill: DISABLE_COLOR };
      if (hover && onClick) {
        styleButton = inverted
          ? { fill: WHITE_COLOR }
          : { fill: PRIMARY_COLOR_HIGHLIGHT };
        color = inverted ? WHITE_COLOR : PRIMARY_COLOR_HIGHLIGHT;
      }
    } else {
      styleButton = inverted
        ? { fill: WHITE_COLOR }
        : { fill: PRIMARY_COLOR_HIGHLIGHT };
      color = inverted ? WHITE_COLOR : PRIMARY_COLOR_HIGHLIGHT;
    }
    const ventilatorSVG = (
      <Ventilator
        className={`ventilator ${inverted ? 'inverted ' : ''}${
          onClick ? 'button' : ''
        } ${disable ? 'disable' : ''} ${size}`}
        color="red"
        style={{ ...styles, ...styleButton }}
        onMouseEnter={this.toggleHover}
        onMouseLeave={this.toggleHover}
      />
    );
    return (
      <Status
        disable={disable}
        stylesBox={stylesBox}
        svgImage={ventilatorSVG}
        onClick={onClick}
        size={size}
        tooltip={tooltip}
        inverted={inverted}
        label={label}
        color={color}
        toggleHover={this.toggleHover}
      />
    );
  }
}

StatusVentilator.propTypes = {
  disable: PropTypes.bool.isRequired,
  styles: PropTypes.objectOf(PropTypes.object),
  stylesBox: PropTypes.objectOf(PropTypes.object),
  onClick: PropTypes.func,
  size: PropTypes.string,
  inverted: PropTypes.bool,
  tooltip: PropTypes.string,
  label: PropTypes.string,
};

StatusVentilator.defaultProps = {
  onClick: null,
  stylesBox: {},
  styles: {},
  size: 'medium',
  inverted: false,
  tooltip: '',
  label: null,
};
